import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ILead } from "../../models/Lead";
import { IVehicle } from "../../models/Vehicle";
import StatusTabs, { StatusTabItem } from "../shared/Tabs/StatusTabs";
import VehicleNotes from "../leads/LeadInformation/VehicleNotes";
import LeadNotes from "../leads/LeadInformation/LeadNotes";

export default function VehicleNotesTabs({ vehicle, lead }: { vehicle: IVehicle; lead?: ILead | null }) {
  const { t } = useTranslation("vehicles");

  const tabs = useMemo<StatusTabItem[]>(() => {
    const items: StatusTabItem[] = [
      {
        key: "vehicle-notes",
        title: t("Vehicle Notes"),
        status: vehicle.notes ? "complete" : "incomplete",
        children: <VehicleNotes vehicle={vehicle} hideCard />,
      },
    ];

    if (lead) {
      items.push({
        key: "yard-notes",
        title: t("Yard Notes"),
        status: lead.yardNotes ? "complete" : "incomplete",
        children: <LeadNotes lead={lead} notesProp="yardNotes" title={t("Yard Notes")} hideCard />,
      });
    }

    return items;
  }, [vehicle, lead, t]);

  return <StatusTabs tabs={tabs} defaultTabKey="vehicle-notes" keepMounted showActiveTitle />;
}
